export default import.meta.ROLLDOWN_FILE_URL_MCLruX_Mp0YsKw8JknsdcQ